import type { UpdateAccountPayload, UpdateAccountResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useUpdateAccount(
  options?: UseMutationOptions<UpdateAccountResponse, unknown, UpdateAccountPayload>,
) {
  return useMutation({
    mutationFn: async ({ account }) => {
      const api = getPrivateApi();

      return api.updateAccount({ updateAccountRequest: { account } });
    },
    ...options,
  });
}
